import React from 'react';
import './TermsHero.css';

const TermsHero = ({
  title = 'Terms and Conditions',
  subtitle = 'Please read these terms carefully before using our platform',
}) => {
  return (
    <section className="terms-hero">
      <div className="container">
        <div className="terms-hero-content">
          <h1 className="terms-title">
            {title}
          </h1>
          <p className="terms-subtitle">
            {subtitle}
          </p>
        </div>
      </div>
    </section>
  );
};

export default TermsHero;
